<template>
	<div class="contract-list">
		<div class="table-wrap">
		  <el-table :data="tableData" border size="small">
		    <el-table-column prop="name" label="有花果收款账户" align="center">
		      <template slot="header" slot-scope="scope">
		        <span class="required-sign"></span>有花果收款账户
		      </template>
		      <template slot-scope="scope">
		          <el-input placeholder="请输入" maxlength="20" v-model="scope.row.name"></el-input>
		      </template>
		    </el-table-column>
			<el-table-column prop="bankOfDeposit" label="开户行" align="center">
			  <template slot="header" slot-scope="scope">
			    <span class="required-sign"></span>开户行
			  </template>
			  <template slot-scope="scope">
			      <el-input placeholder="请输入" maxlength="20" v-model="scope.row.bankOfDeposit"></el-input>
			  </template>
			</el-table-column>
			<el-table-column prop="account" label="收款账户" align="center">
			  <template slot="header" slot-scope="scope">
			    <span class="required-sign"></span>收款账户
			  </template>
			  <template slot-scope="scope">
			      <el-input placeholder="请输入" v-model="scope.row.account" maxlength="20" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
			  </template>
			</el-table-column>
			<el-table-column prop="sort" label="下拉顺序" align="center">
			  <template slot="header" slot-scope="scope">
			    <span class="required-sign"></span>下拉顺序(从小到大)
			  </template>
			  <template slot-scope="scope">
			     <el-input v-model="scope.row.sort" maxlength="3" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" ></el-input>
			  </template>
			</el-table-column>
			<el-table-column  prop="isEnable" label="启用" align="center" width="100">
			  <template slot="header" slot-scope="scope">
				  <span class="required-sign"></span>启用
			  </template>
			  <template slot-scope="scope">
				   <el-switch v-model="scope.row.isEnable">
				   </el-switch>
			  </template>
			</el-table-column>
		    <!-- 操作 -->
		    <el-table-column fixed="right" label="操作" width="100" align="center">
		      <template slot="header" slot-scope="scope">
		        <el-button type="primary" size="mini" @click="addCustomPrice" class="btn--red">+ 新增</el-button>
		      </template>
		      <template slot-scope="scope">
		        <el-button
		          v-if="scope.row.isDel==1"
		          type="text"
		          class="color_red"
		          icon="el-icon-remove-outline"
		          style="font-size: 32px; margin-bottom: 20px; cursor: pointer;"
		          circle
		          @click="delPrice(scope.$index)"
		        ></el-button>
		      </template>
		    </el-table-column>
		  </el-table>
		  <span>Tips：一旦新增有花果收款账号提交后，将不能删除，可以禁用。</span> 
		  <div style="text-align:center;margin-top: 50px;" >
		   <el-button style="width:120px;" @click="saveClick('ruleForm')" type="primary">提交</el-button>
		  </div>
		</div>
	</div>
</template>

<script>
	import * as qiniu from "qiniu-js"; 
	import { qiniuToken } from "@/api/index";
	import XLSX from "xlsx";
	import {
		mapGetters
	} from "vuex";
	import validate from "@/util/validate";
	import util from "@/util/util";
	import {
		contractConfig
	} from "@/const/config/contract";
	import InvoiceFormFields from "@/const/form/InvoiceForm";
	import {
		billingConfig
	} from "@/const/config/billing";
	import {
		zhList,zhComit
	} from "./index.js";
	import {
		processList
	} from "@/api/approve/contract";
	import approveList from "@/components/common/approveMember";
	export default {
		components: {

		},
		data() {
			return {
				tableData:[
					{
						  name:'',//有花果收款账号
						  bankOfDeposit:'',//开户行
						  account:'',//收款账号
						  sort:'',//排序
						  isEnable:true,
					}
				],
				fileData:null,//导入文件
				fileName:'',//文件名称
				voucher:'',//上传回款凭证
				drBack:{},//导入返回数据
				drhkStatus:false,//导入状态开关
				hkid:'',//合同id
				zfForm:{
					"id":null,
					"returnMoneyId":null,
					"contractId": null,
					"reason":"",
					"deleteFlag": 0
				},
				costType:[
						  {label:'外包服务',value:1},
						  {label:'媒介采买',value:2},
						  {label:'杂费',value:3},
						  {label:'内部采买',value:4},
				],//回款类型
				sealType:[
					{label:'不盖章',value:0},
					{label:'公章',value:1},
					{label:'合同章',value:2},
				],//
				sealStatus:[
						  {label:'不盖章',value:0},
						  {label:'待申请盖章',value:1},
						  {label:'盖章审核中',value:2},
						  {label:'盖章审核不通过',value:3},
						  {label:'待盖章',value:4},
						  {label:'已盖章',value:5},
						  {label:'已作废',value:6},
				],
				auditStatus:[
					{label:'待直属上级审批',value:1},
					{label:'直属上级审批不通过',value:2},
					{label:'直属上级审批通过',value:3},
				],//审批状态
				zfData:{},//作废信息
				rlData:[],//认领记录
				fileList: [], //凭证
				billingConfig,
				uphkVisible:false,//上传回款凭证
				approveVisible: false,
				approveLoading: false,
				Invoicedialog: false, //回款详情
				approveTitle: false,
				invoiceVisible: false, //作废详情
				zftxVisible: false, //作废提醒
				drhkVisible: false, //导入回款
				/**
				 * 开票提醒模块
				 */
				isUploadFile: false, //是否上传
				hasCorrectIncome: false, //KOL收入+有花果收入=净收入
				hasRemainingMoney: false, //剩余金额大于可开票金额


				contractConfig: contractConfig,
				form: {
					nameOrCode: "",
					customerName: "",
					contractMoneyMin: "",
					contractMoneyMax: "",
					statusList: "",
				},
				  InvoiceForm: {
						// account: "",
						// bankAccount: null,
						// bankDeposit: "",
						// bankSerialNumber: "",
						// claimMoney: null,
						// createTime: "",
						// createUserId: "",
						// createUserName: "test",
						// deleteFlag: null,
						// payeeName: "",
						// payer: "",
						// remark: "",
						// returnMoney: 0,
						// returnTime: "",
						// returnType: 1,
						// status: 1,
						// voucher: "",
						// waitClaimMoney: 0,
				  },
				rules: {

				},
				tableLoading: false,
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			...mapGetters(["permissions", "dicts"]),
		},
		methods: {
			  //新增联系方式
			  addCustomPrice() {
				this.tableData.push(
				  {
					  name:'',//有花果收款账号
					  bankOfDeposit:'',//开户行
					  account:'',//收款账号
					  sort:'',//排序
					  isEnable:true,
					  isDel:1,
				  }
				)
			  },
			  // 删除联系方式
			  delPrice(index) {
				this.tableData.splice(index, 1)
			  },
			//获取文件后缀名
			getWordname(str){
				var index = str.lastIndexOf("\/");  
				str  = str.substring(index + 1, str .length);
				return str
			},
			//确认删除
			zfSubmit(){
				zfZl(this.zfForm)
				  .then((res) => {
						if(res.code == 1){
							this.$message({
							  message: '作废成功',
							  type: 'success'
							});
						}
					this.zftxVisible = false
				  })
				  .catch((err) => {
							
				  });
			},
			//提交
			saveClick() {
				zhComit(this.tableData).then((res) => {
					if (res.code == 1) {
						this.$message.success("提交成功！");
						this.getList();
					}
				});
			},
			// 获取列表
			getList() {
			  const obj = {
				  type : 0
			  }
			  zhList(obj)
				.then((res) => {
					console.log(res)
				  this.tableData = res.data || [];
				})
				.catch((err) => {
					
				});
			},
		},

	};
</script>

<style lang="scss" scoped>
	.dz-img {
		display: block;
		width: 90px;
		height: 100px;
		margin: 0 auto;
	}

	.dz-title {
		font-size: 30px;
		color: #000;
		font-weight: bold;
		text-align: center;
		padding: 10px;
	}

	.dz-text {
		text-align: center;
		padding: 20px;
	}

	.dz-info {
		display: flex;
		justify-content: space-around;
		padding: 20px;
	}

	.table-wrap {
		margin-top: 20px;
	}

	.mar-c {
		display: flex;
		justify-content: center;
	}

	.table-count {
		margin: 15px 0 10px;
	}

	// 列表item
	.block-form-item {
		&.w-32 {
			display: inline-block;
			width: 32%;
			margin-right: 1%;
			height: 64px;
		}

		&.w-99 {
			width: 99%;
			margin-right: 1%;
		}
	}

	.yhg-dialog {
		.select-con {
			display: flex;

			.label {
				white-space: nowrap;
			}

			.select-tag {
				margin-right: 5px;
				margin-bottom: 5px;
			}

			.select-tag-text {
				display: inline-block;
				max-width: 86px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.filter-con {
			display: flex;
			align-items: center;
			margin: 20px 0;
			width: 800px;

			.label {
				white-space: nowrap;
			}

			.search-btn {
				margin-left: 15px;
			}
		}

		.submit-con {
			margin-top: 20px;
			text-align: right;
		}
	}

	.select-input-wrap-s {
		.el-input-group__append {
			position: relative;
			width: 32px;
			height: 32px;
			border: none;
			background: #fff;
			padding: 0;
			color: #409eff;

			.iconfont {
				position: absolute;
				top: -2px;
				left: -1px;
				font-size: 33px !important;
			}

			cursor: pointer;
		}
	}

	.select-con {
		.el-tag .el-icon-close {
			top: -8px;
		}
	}

	.avue-view .cost-table {
		width: calc(50% + 100px);

		th {
			background: none;
			font-weight: normal;
			font-size: 14px;
		}

		.cell {
			padding-left: 0;
		}
	}

	.el-table .operate-column {
		vertical-align: text-top;
	}

	/deep/.el-dialog__header {
		border-bottom: 1px solid #ccc !important;
	}

	.invoiceList {
		display: flex;
		justify-content: space-between;
	}

	.mt-10 {
		margin-top: 10px;
	}
</style>
<style>
	.el-dialog {
	    width: 70%;
	}
	.el-icon-delete-solid:hover{
		color: #66B1FF;
	}
	.el-icon-delete-solid{
		cursor: pointer;
	}
</style>
